





























import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
import { Component, Prop } from "vue-property-decorator";
import TitleComponents from "./Title/Title.vue";
import TitleSearchComponents from "./Search/TitleSearch.vue";
import DialogComponents from "./../../Dialog/Dialog.vue";
import ButtonsComponents from "./Buttons/Buttons.vue";
import ProgressLinearComponents from "./ProgressLinear/ProgressLinear.vue";
import SimpleSearchComponents from "./Search/SimpleSearch.vue";
import NotifyComponents from "./../../Notify/Notify.vue";
import TooltipsComponents from "./../../Tooltips/CRUD/Tooltips.vue";
import WorkflowComponents from "./Workflow/Workflow.vue";
Vue.use(Vuex, Axios);

/*
    * Component's properties and events
*/
@Component({
      components: {
        TitleComponents,
        TitleSearchComponents,
        DialogComponents,
        ButtonsComponents,
        ProgressLinearComponents,
        SimpleSearchComponents,
        NotifyComponents,
        TooltipsComponents,
        WorkflowComponents
    }
})

export default class HeaderComponent extends Vue {
    /*
        *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
    */
    get settings() {
        // @ts-ignore
        return this.$store.state[this.$options.parent.fileName];
    }
}
